import { processProperties, processCompoundedProperties } from './process.js';
import { formSerializer, themeSerializer } from './instantiate.js';
import { showConsoleLogs } from './utils.js';

// /** The id of the theme or form */
// id: string = '',
// /** The type, either a theme or form */
// type: string,
// /** The customizations to generate CSS from */
// customizations: customization[],
// /** Whether or not we're in preview mode */
// isPreview: boolean,
// /** Whether or not we're previewing a theme */
// isThemePreview: boolean,
var tagGenerator = function tagGenerator(_tagGenerator) {
  try {
    var id = _tagGenerator.id,
      type = _tagGenerator.type,
      customizations = _tagGenerator.customizations,
      isPreview = _tagGenerator.isPreview,
      isThemePreview = _tagGenerator.isThemePreview;
    var styles = '';
    var videoTagUrl = '';
    var fontFaces = '';
    var isForm = type === 'form';
    var customizationsPlus = [].concat(customizations);

    // this is in case a user changes the page or block background value on their form
    // because we don't give them the ability to edit the page or block contrast color yet on a page by page basis, we need to add it here
    // values need to be set because of an issue in the property serializer but we're not actually using them for these
    var pageBackgroundCustomization = customizationsPlus === null || customizationsPlus === void 0 ? void 0 : customizationsPlus.filter(function (c) {
      return (c === null || c === void 0 ? void 0 : c.property) === 'page-background-value';
    });
    var blockBackgroundCustomization = customizationsPlus === null || customizationsPlus === void 0 ? void 0 : customizationsPlus.filter(function (c) {
      return (c === null || c === void 0 ? void 0 : c.property) === 'block-background-value';
    });
    if (pageBackgroundCustomization.length > 0) {
      var pageContrastColor = customizationsPlus === null || customizationsPlus === void 0 ? void 0 : customizationsPlus.filter(function (c) {
        return (c === null || c === void 0 ? void 0 : c.property) === 'page-contrast-color';
      });
      var pageButtonContrastColor = customizationsPlus === null || customizationsPlus === void 0 ? void 0 : customizationsPlus.filter(function (c) {
        return (c === null || c === void 0 ? void 0 : c.property) === 'page-button-contrast-color';
      });
      if (pageContrastColor.length === 0) {
        customizationsPlus.push({
          id: 'fake-id-1',
          property: 'page-contrast-color',
          type: 'style',
          value: '#FFFFFF'
        });
      }
      if (pageButtonContrastColor.length === 0) {
        customizationsPlus.push({
          id: 'fake-id-2',
          property: 'page-button-contrast-color',
          type: 'style',
          value: '#000000'
        });
      }
    }
    // console.log('blockBackgroundCustomization', blockBackgroundCustomization)
    // we haven't added the block-contrast-color or block-button-contrast-color to the api yet for users to be able to edit, so we need to add it here

    if (blockBackgroundCustomization.length > 0) {
      var blockContrastColor = customizationsPlus.filter(function (c) {
        return (c === null || c === void 0 ? void 0 : c.property) === 'block-contrast-color';
      });
      var blockButtonContrastColor = customizationsPlus.filter(function (c) {
        return (c === null || c === void 0 ? void 0 : c.property) === 'block-button-contrast-color';
      });
      if (blockContrastColor.length === 0) {
        customizationsPlus.push({
          id: 'fake-id-3',
          property: 'block-contrast-color',
          type: 'style',
          value: '#000000'
        });
      }
      if (blockButtonContrastColor.length === 0) {
        customizationsPlus.push({
          id: 'fake-id-4',
          property: 'block-button-contrast-color',
          type: 'style',
          value: '#000000'
        });
      }
    }
    var memo = id ? id : 'new';
    var serializer = isForm ? formSerializer(memo) : themeSerializer(memo);
    var _processProperties = processProperties(customizationsPlus, isForm, serializer, isPreview, isThemePreview),
      css = _processProperties.css,
      compoundedProperties = _processProperties.compoundedProperties,
      cssVariables = _processProperties.cssVariables;
    var _processCompoundedPro = processCompoundedProperties(compoundedProperties, isForm, isPreview, isThemePreview),
      compoundedCss = _processCompoundedPro.compoundedCss,
      compoundedCssVariables = _processCompoundedPro.compoundedCssVariables;
    var pageFontBody = serializer.getByApiPropertyName('page-font-body');
    var pageFontHeading = serializer.getByApiPropertyName('page-font-heading');
    var body = getFontSource(pageFontBody);
    var heading = getFontSource(pageFontHeading);
    if (heading !== null && heading !== undefined) {
      fontFaces += heading;
    }
    if (body !== null && body !== undefined) {
      fontFaces += body;
    }
    styles = "\n/* " + type + "_id: " + memo + " */\n\n";
    if (fontFaces) {
      styles += "/* fontFaces */\n";
      styles += "" + fontFaces;
      styles += "\n/* end fontFaces */\n";
    }
    if (cssVariables) {
      styles += "/* cssVariables */\n";
      styles += "" + cssVariables;
      styles += "\n/* end cssVariables */\n";
    }
    if (compoundedCssVariables) {
      styles += "/* compoundedCssVariables */\n";
      styles += compoundedCssVariables + "\n";
      styles += "\n/* end compoundedCssVariables */\n";
    }
    if (compoundedCss) {
      styles += "/* compounded properties css */\n";
      // console.log('css', compoundedCss)
      styles += "" + compoundedCss;
      styles += "/* end compounded properties css */\n";
    }
    if (css) {
      styles += "/* properties css */\n";
      styles += "" + css;
      styles += "/* end properties css */\n";
    }
    styles += "\n/* end " + type + "_id: " + memo + " */\n";
    styles += "\n/* text sizes */\n:root {\n    --p-font-size: 0.875rem;\n    --h1-font-size: 1.5rem;\n    --h2-font-size: 1.125rem;\n    --h3-font-size: 1rem;\n    --h4-font-size: 0.875rem;\n}\n\n#preview p, #theme-preview p, #form p,\n#preview span, #theme-preview span, #form span,\n#preview label, #theme-preview label, #form label,\n#preview div, #theme-preview div, #form div  {\n    font-size: var(--p-font-size);\n}\n\n#preview h1, #theme-preview h1, #form h1 {\n    font-size: var(--h1-font-size);\n}\n\n#preview h2, #theme-preview h2, #form h2 {\n    font-size: var(--h2-font-size);\n}\n\n#preview h3, #theme-preview h3, #form h3 {\n    font-size: var(--h3-font-size);\n}\n\n#preview h4, #theme-preview h4, #form h4 {\n    font-size: var(--h4-font-size);\n    font-weight: bold;\n}\n/* end text sizes */\n\n        ";
    styles += "\n/* account menu variables */\n#menu {\n    --block-background-value: #FFFFFF;\n    --block-contrast-color: var(--linkColor);\n    --block-button-contrast-color: #000000;\n    --page-background-value: var(--linkColor);\n    --page-contrast-color: var(--contrastColor);\n    --page-button-contrast-color: var(--contrastColor);\n    --block-border-radius: 0.5rem;\n    --block-border-width: 0;\n    --block-shadow-style: none;\n    --page-font-heading: -apple-system, \"system-ui\", \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --page-font-body: -apple-system, \"system-ui\", \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n#menu p, #menu span, #menu label, #menu div, #menu input, #menu li, #menu ol {\n    font-family: var(--page-font-body);\n}\n#menu h1, #menu h2, #menu h3, #menu h4, #menu h5, #menu h6, #menu blockquote, #menu blockquote > div > span > span {\n    font-family: var(--page-font-heading);\n}\n/* end menu variables */\n\n        ";
    var pageBackgroundType = serializer.getByApiPropertyName('page-background-type');
    if ((pageBackgroundType === null || pageBackgroundType === void 0 ? void 0 : pageBackgroundType.value) === 'video') {
      var pageBackground = serializer.getByApiPropertyName('page-background-value');
      videoTagUrl = pageBackground.value;
    }
    if (showConsoleLogs()) {
      console.groupCollapsed("1. [" + type + "] tagGenerator");
      console.count('tagGenerator');
      console.log('Called with id', id);
      console.log('type', type);
      console.log('customizationsPlus', customizationsPlus);
      console.log('returns styles', styles);
      console.log('videoTagUrl', videoTagUrl);
      console.groupEnd();
    }
    // console.log('sttyles', styles, linkColor, videoTagUrl, type, serializer)
    return Object.assign({
      styles: styles
    }, videoTagUrl && {
      videoTagUrl: videoTagUrl
    }, {
      type: type,
      serializer: serializer
    });
  } catch (error) {
    console.error(error);
  }
};
var getFontSource = function getFontSource(fontProperty) {
  if (fontProperty._hasBeenModified) {
    var fontNameProperty = fontProperty.value;
    var name = fontNameProperty.split(',')[0].replace(/['"]/g, '');
    var filename = name.toLowerCase().replace(/\s+/g, '-');
    return "\n@font-face {\n    font-display: swap;\n    font-family: " + name + ";\n    src: url('/assets/fonts/" + filename + ".woff2');\n    src: url('/assets/fonts/" + filename + ".woff');\n}\n";
  }
};

export { tagGenerator as default };
//# sourceMappingURL=tagGenerator.js.map
